export default {
  accordion: {
    switchLabel: {
      open: 'Enabled',
      closed: 'Disabled',
    },
    toggleLabel: {
      open: 'Hide this section',
      closed: 'Show this section',
    },
  },
  general: {
    // Used in a button (as an action)
    cancel: 'Cancel',
    // Appended to required form field labels
    requiredInline: '(required)',
    search: 'Search',
    // Used after other statements, like in the case of filters: "Refunded: yes"
    yes: 'yes',
  },
  fileManager: {
    chooseFiles: 'Choose file(s)',
    deleteFile: 'Delete file',
  },
  filters: {
    afterDate: 'After {date}',
    apply: 'Apply',
    beforeDate: 'Before {date}',
    betweenDate: 'Between {start} and {end}',
    clear: 'Clear',
    endDate: 'End date',
    filters: 'Filters',
    startDate: 'Start date',
    textSearch: 'Text search',
  },
  imageManager: {
    chooseExisting: 'Choose existing',
    deleteImage: 'Delete image',
    // Separates the actions ("upload images" and "use existing")
    or: 'or',
    // Used in a button (as an action)
    select: 'Select',
    selectImages: 'Select image(s)',
    uploadImages: 'Upload image(s)',
  },
  navigation: {
    returnToHome: 'Return to the home page',
    skip: 'Skip navigation',
  },
  paginate: {
    goToFirst: 'Go to the first page',
    goToNext: 'Go to the next page',
    goToPrevious: 'Go to the previous page',
    goToLast: 'Go to the last page',
    showing: 'Showing',
    of: '{x} of {y}',
  },
  tag: {
    dismiss: 'Dismiss',
    reset: 'Reset',
  },
  wysiwyg: {
    bold: 'Bold',
    italic: 'Italic',
    h1: 'Header 1',
    h2: 'Header 2',
    h3: 'Header 3',
    blockquote: 'Blockquote',
    bulletlist: 'Bullet list',
  },
};
